/**
 * @license lucide-react v1.59.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.mjs';

const __iconData = {
  name: "face-grinning",
  size: 24,
  node: [
    ["path", { d: "M15 10V9", key: "4dkmfx" }],
    [
      "path",
      {
        d: "M7.084 14.302a5.12 5.12 0 009.833 0 .24.24 0 00-.235-.302H7.32a.24.24 0 00-.235.302",
        key: "1ad3z7"
      }
    ],
    ["path", { d: "M9 10V9", key: "1lazqi" }],
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
  ],
  aliases: ["laugh"]
};
__iconData.node;
const FaceGrinning = createLucideIcon(__iconData);

export { __iconData, FaceGrinning as default };
//# sourceMappingURL=face-grinning.mjs.map
